import '../App.css'
import logoLeonCompletoNLBlanco from '../assets/logo_leon_completo_nl_blanco.svg';
import iconFacebook from '../assets/icon-facebook2.png';
import iconInstagram from '../assets/icon-instagram2.png';
import iconTwitter from '../assets/icon-twitter2.png';
import iconTelegram from '../assets/icon-telegram2.png';
import iconTiktok from '../assets/icon-tiktok2.png';
import iconYoutube from '../assets/icon-youtube2.png';
import leondorado from '../assets/logo_leondorado.svg';
import logocabeza from '../assets/logo_tesoreria.png'
import { Link } from 'react-router-dom';
import { Box, Container, Grid, Typography, Link as LinkMui } from '@mui/material';

const iconMap: Record<string, string> = {
  iconFacebook,
  iconInstagram,
  iconTwitter,
  iconTelegram,
  iconTiktok,
  iconYoutube,
};

const Footer = ({ links }: { links: any[] }) => {
  const redesLinks = links.filter((l) => l.zona === 'REDES' && l.es_icono === 1);
  const gobiernoLinks = links.filter((l) => l.zona === 'GOBIERNO');
  const pieLinks = links.filter((l) => l.zona === 'PIE');
  return (
    <div>


      <Box sx={{ width: "100%", backgroundColor: "#ff8400", color: "#fff", mt: 6 }}>
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Grid container alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
            <Grid item>
              <Link to="/">
                <Box
                  component="img"
                  src={logocabeza}
                  alt="Gobierno de Nuevo León"
                  sx={{ height: 120 }}
                />
              </Link>
            </Grid>

            <Grid item>
              <Link to="/">
                <Box
                  component="img"
                  src={logoLeonCompletoNLBlanco}
                  alt="Gobierno de Nuevo León"
                  sx={{ height: 120 }}
                />
              </Link>
            </Grid>
          </Grid>
          <Grid container justifyContent="space-between" alignItems="flex-start" spacing={2}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                {pieLinks.map((item: any, idx: number) => (
                  <LinkMui
                    key={idx}
                    href={item.link}
                    underline="hover"
                    sx={{ color: "#fff", fontSize: 14 }}
                  >
                    {item.texto}
                  </LinkMui>
                ))}
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ textAlign: { xs: "left" } }}>
                <Box sx={{ display: "flex", gap: 1, justifyContent: { xs: "flex-start", md: "flex-end" } }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Mantente informado:
                  </Typography>
                  {redesLinks.map((link: any, idx: number) => (
                    <a key={idx} href={link.link} target="_blank" rel="noreferrer">
                      <Box
                        component="img"
                        src={iconMap[link.texto] || iconFacebook}
                        alt={link.texto}
                        sx={{ width: 32, height: 32 }}
                      />
                    </a>
                  ))}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <section className="seccion_leyenda">
        <div className="primera_leyenda">Gobierno de <strong>nuevo león</strong></div>
        <div className="logo_leyenda">
          <img decoding="async" src={leondorado} alt="" className="style-svg" />
        </div>
        <div className="segunda_leyenda">Un <strong>nuevo</strong> nuevo león</div>
      </section>
    </div>
  );
};

export default Footer;
